import {
    PAYMENT_METHOD_CREDIT_CARD,
    PAYMENT_METHOD_PAYPAL,
    PAYMENT_METHOD_PAYPAL_RATE_PAY,
    PAYMENT_METHOD_PREPAYMENT,
    PAYMENT_METHOD_SEPA,
    PAYMENT_METHOD_PLEDG_RATE_PAY,
    PAYMENT_METHOD_CHRYSALIS_RATE_PAY,
    PAYMENT_METHOD_KLARNA
} from '../../../constant/sales-order-constant'

export const REDUCER_NAME = 'sales-order'

export const PRODUCT_TYPE = {
    'set': 'Set',
    'treatment': 'Treatment',
    'treatment-new': 'Treatment New',
    'end-of-treatment': 'End Of Treatment',
    'shop-scan': 'Shop Scan',
    'shop-scan-new': 'Shop Scan New',
    'retainer': 'Retainer',
    'retainer-new': 'Retainer New',
    'refinement-set': 'Refinement (Set)',
    'refinement-booking': 'Refinement (Booking)',
    'refinement-shop': 'Refinement (Shop)',
    'refinement-shop-new': 'Refinement (Shop New)',
    'refinement-production': 'Refinement Production',
    'in-shop-scan': 'Clinic 3D-Scan',
    'in-shop-scan-new': 'Clinic 3D-Scan New',
    'escalation': 'Escalation',
    'check-in': 'Clinic Check-In',
    'aligner-reproduction': 'Aligner Reproduction',
    'implant-3d-scan': 'Implant Clinic 3D-Scan',
    'implant-plan': 'Implant Plan',
    'implant-treatment': 'Implant Treatment',
    'retainer-refinement': 'Retainer Refinement',
    'retainer-refinement-new': 'Retainer Refinement New',
    'partial-refund': 'Partial Refund',
}

export const PAYMENT_METHOD_TEXT = {
    [PAYMENT_METHOD_CREDIT_CARD]: 'credit card',
    [PAYMENT_METHOD_SEPA]: 'direct debit',
    [PAYMENT_METHOD_PAYPAL_RATE_PAY]: 'payPal ratePay',
    [PAYMENT_METHOD_PAYPAL]: 'PayPal',
    [PAYMENT_METHOD_PREPAYMENT]: 'prepayment',
    [PAYMENT_METHOD_CHRYSALIS_RATE_PAY]: 'Chrysalis Ratepay',
    [PAYMENT_METHOD_KLARNA]: 'Klarna',
    zab_invoice: 'ZAB Invoice',
    zab_ratepay: 'ZAB Ratepay',
    tabeo_ratepay: 'Tabeo Ratepay',
    chrysalis_ratepay: 'Chrysalis Ratepay',
    pagamastarde_ratepay: 'PagaMasTarde',
    splitit_ratepay: 'SplitIt',
    ideal: 'iDEAL',
    bancontact: 'Bancontact',
    [PAYMENT_METHOD_PLEDG_RATE_PAY]: 'Pledg',
    null: 'none',
}

export const PAYMENT_METHOD_SELECT = Object.keys(PAYMENT_METHOD_TEXT).map(key => ({
    id: key,
    value: PAYMENT_METHOD_TEXT[key],
}))



// WEBPACK FOOTER //
// ./src/modules/sales-order/state/const.js